import { Badge } from '@/components/ui/badge'
import type { ApiKeyStatus } from '@/types/api-keys.types'

interface ApiKeyStatusBadgeProps {
  status: ApiKeyStatus
}

export function ApiKeyStatusBadge({ status }: ApiKeyStatusBadgeProps) {
  const variant = status === 'Active' ? 'default' : status === 'Expired' ? 'secondary' : 'destructive'

  return (
    <Badge variant={variant}>
      {status}
    </Badge>
  )
}
